export interface GetLandOrderListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetLandOrderListPagingAndFilterResponseData
}

export interface GetLandOrderListPagingAndFilterResponseData {
    items: GetLandOrderListPagingAndFilterResponseItem[]
    totalRecordCount: number
    totals: GetLandOrderListPagingAndFilterResponseTotals | undefined
}

/** Görüntülenen sayfadaki kayıtların dip toplamı. */
export interface GetLandOrderListPagingAndFilterResponseTotals {
    totalQuantity: number
    totalWeight: number
    totalDesi: number
    totalVolume: number
    totalPriceWeight: number
    rowCount: number
}

export interface GetLandOrderListPagingAndFilterResponseItem {
    landOrderId: string
    companyId: string
    refNo: string
    customerId: string
    operationTypeId: string
    incotermId: string
    orderStatusId: string
    customerName: string
    operationTypeName: string
    incotermName: string
    orderStatusName: string
    senderFirmAddressId: string
    receiverFirmAddressId: string
    loadingFirmAddressId: string
    unloadingFirmAddressId: string
    dutyFirmId: string
    senderFirmId: string
    senderFirmName: string
    senderFirmAddressTypeId: string
    senderFirmAddressTypeName: string
    senderFirmAddressText: string
    receiverFirmId: string
    receiverFirmName: string
    receiverFirmAddressTypeId: string
    receiverFirmAddressTypeName: string
    receiverFirmAddressText: string
    loadingFirmId: string
    loadingFirmName: string
    loadingFirmAddressTypeId: string
    loadingFirmAddressTypeName: string
    loadingFirmAddressText: string
    unloadingFirmId: string
    unloadingFirmName: string
    unloadingFirmAddressTypeId: string
    unloadingFirmAddressTypeName: string
    unloadingFirmAddressText: string
    dutyFirmName: string
    orderDate: string
    loadingDate: string
    deliverDate: string
    estDeliverDate: string
    voyageStatusId: string
    voyageNo: string
    vehicleId: string
    trailerId: any
    driverId: string
    supplierId: string
    voyageStatusName: string
    vehicleName: string
    trailerName: any
    driverName: string
    supplierName: string
    orderDetails: GetLandOrderListPagingAndFilterResponseOrderDetail[]
    expectedIncomeOutcomes: GetLandOrderListPagingAndFilterResponseExpectedIncomeOutcome[]
    fileArchives: GetLandOrderListPagingAndFilterResponseFileArc[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetLandOrderListPagingAndFilterResponseOrderDetail {
    orderDetailId: string
    orderId: string
    potTypeId: string
    quantity: number
    gTipId: string
    product: string
    width: number
    length: number
    height: number
    volume: number
    desi: number
    weight: number
    priceWeight: number
    currencyTypeId: string
    potTypeName: string
    gTipName: string
    currencyTypeName: string
}

export interface GetLandOrderListPagingAndFilterResponseExpectedIncomeOutcome {
    expectedIncomeOutcomeId: string
    orderId: string
    isIncome: boolean
    serviceId: string
    unitPrice: number
    quantity: number
    currencyTypeId: string
    totalPrice: number
    taxPrice: number
    totalWithoutTaxPrice: number
    currency?: number
    description?: string
    invoiceNo?: string
    invoiceDate?: string
    isApproved: boolean
    serviceName: string
    currencyTypeName: string
    taxRate: string
}

export interface GetLandOrderListPagingAndFilterResponseFileArc {
    fileArchiveId: string
    entityId: string
    fileName: string
    url: string
    fileTypeId: string
    description: string
    fileTypeName: string
    createdDate: string
}

export const initialGetLandOrderListPagingAndFilterResponseData: GetLandOrderListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0,
    totals: undefined
}